import { isEmpty } from '../utils/bits'
import { isFunction } from 'lodash-es'

import debugFields from '../utils/debug-fields'

import {
  signOverrideByKey,
  signOverrideByEnv,
  signOverrideByConst
} from './gallery-properties.flow'

export function OverrideByKey(...getKeys) {
  return signOverrideByKey(Override(true, getKeys))
}

export function OverrideByEnv(...getEnvs) {
  return signOverrideByEnv(Override(false, getEnvs))
}

export function OverrideByConst(...getConstants) {
  return signOverrideByConst(Override(false, getConstants))
}

export function Override(useCalcProp, getOverrides) {
  return debugFields(override, {
    _getOverrides: getOverrides
  })

  function override(rawVal, calcProp) {
    let result = isEmpty(rawVal) ? null : rawVal
    for (const getOverride of getOverrides) {
      const overrideVal = isFunction(getOverride)
        ? getOverride(rawVal, calcProp)
        : useCalcProp
          ? calcProp(getOverride)
          : getOverride

      if (!isEmpty(overrideVal)) {
        result = overrideVal
      }
    }
    return result
  }
}
